var Arabic = "Arabic (عربي)";
var Catalan = "Catalan (Català)";
var Chinese = "Simplified Chinese (中文)";
var Czech = "Czech (Čeština)";
var Danish = "Danish (Dansk)";
var Dutch = "Dutch (Nederlands)";
var English = "English (US)";
var French = "French (Français)";
var German = "German (Deutsch)";
var Greek = "Greek (Ελληνικά)";
var Italian = "Italian (Italiano)";
var Japanese = "Japanese (日本語)";
var Korean = "Korean (한국어)";
var Norwegian = "Norwegian (Norsk)";
var Polish = "Polish (Polski)";
var Russian = "Russian (Pусский)";
var Spanish = "Spanish (Español)";
var Swedish = "Swedish (Svenska)";
var Taiwanese = "Traditional Chinese (正體中文)";
var Turkish = "Turkish (Türkçe)";
var EN_TRANSLATION = {
  Arabic: Arabic,
  Catalan: Catalan,
  Chinese: Chinese,
  Czech: Czech,
  Danish: Danish,
  Dutch: Dutch,
  English: English,
  French: French,
  German: German,
  Greek: Greek,
  Italian: Italian,
  Japanese: Japanese,
  Korean: Korean,
  Norwegian: Norwegian,
  Polish: Polish,
  "Portuguese (BR)": "Portuguese (Português - Brasil)",
  "Portuguese (PT)": "Portuguese (Português - Portugal)",
  Russian: Russian,
  "Select Language": "Select Language",
  Spanish: Spanish,
  "Spanish (ES)": "Spanish (España)",
  "Spanish (MX)": "Spanish (México)",
  Swedish: Swedish,
  Taiwanese: Taiwanese,
  Turkish: Turkish
};
export { Arabic, Catalan, Chinese, Czech, Danish, Dutch, English, French, German, Greek, Italian, Japanese, Korean, Norwegian, Polish, Russian, Spanish, Swedish, Taiwanese, Turkish, EN_TRANSLATION as default };
//# sourceMappingURL=en.json.mjs.map
